module.exports = __webpack_public_path__ + "static/media/negotiation-active.b6c09640.svg";